<template>
  <div class="container">
    <custom-select
      label="Situación laboral"
      :value="value"
      name="situacionLaboral"
      @input="onChange"
      :items="situaciones"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import { situacionesLaborales } from "@/config/constants/index";
import CustomSelect from "@/components/core/custom/CustomSelect";
export default {
  name: "EmploymentSituation",
  components: { CustomSelect },
  props: {
    value: String,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    situaciones() {
      return situacionesLaborales;
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
    }
  }
};
</script>
